import { Box, Button } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import AppNav from '@sophocles/components/App/AppNav';
import TitleBar from '@sophocles/components/App/TitleBar';
import ProductGrid from '@sophocles/views/sales/components/ProductGrid';

function ProductListView() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const breadcrumbs = [
    { label: t('warehouse.sales', 'Sales'), to: '/sales/orders' },
    { label: t('general.products', 'Products') },
  ];

  return (
    <AppNav flex notFullHeight loading={false} page="sales_products">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          overflow: 'hidden',
          padding: '0 var(--page-px) var(--page-py)',
        }}
      >
        <TitleBar
          breadcrumbs={breadcrumbs}
          items={[
            <Button key="inventory" variant="contained" onClick={() => navigate('/sales/reports/inventory-log')}>
              {t('warehouse.inventoryLog', 'Inventory Log')}
            </Button>,
          ]}
        />
        <ProductGrid />
      </Box>
    </AppNav>
  );
}

export default ProductListView;
